import React, { Fragment, useState } from "react";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import DatePicker from "react-datepicker";
import Checkbox from '@mui/material/Checkbox';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getCountryCodeISO } from "../../utils/general";
import { getNotificationPermission } from "./notificationConstant";
import { selectMenuProps } from "../../utils/selectMenuProps";
import FormControlLabel from '@mui/material/FormControlLabel';

const selectInputSx = { height: 40, minHeight: 40, width: "100%", boxSizing: "border-box" };
const selectValuesSx = (theme) => ({ width: "100%", minWidth: 0, [theme.breakpoints.up('md')]: { maxWidth: 280 } });
const formControlSx = (theme) => ({ width: "100%", minWidth: 0, boxSizing: "border-box", [theme.breakpoints.up('md')]: { maxWidth: 280 } });
const userSelectionFieldRowSx = {
  display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", marginBottom: "16px",
  "& > label": { flex: "0 0 200px", width: 200, minWidth: 200, margin: 0, whiteSpace: "nowrap", boxSizing: "border-box" },
  "& > div": { flex: "0 1 auto", minWidth: 0, maxWidth: 280, width: 280 },
};
const userSelectionBlockSx = {
  "& > div": { marginBottom: "16px" },
  "& > div:last-child": { marginBottom: 0 },
};

const headers = {
    productSerialNumber: "Product Serial Number",
    status: "QR Code Print Status",
    reasonOfFailure: "Reason of Failure"
};

const UserSelection = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries = [],
    setAlert,
    country,
    deviceOwnership,
    userStartLastLogin,
    userEndLastLogin,
    handleUserCountries,
    handleUserDeviceOwnership,
    handleUserStartLastLogin,
    handleUserEndLastLogin,
    uploadedUserIdFileInput,
    userIdCSVFileInputRef,
    handleUserIdFileInput,
    userLevel,
    broadcastNotification,
    handleBroadcastNotification
}) => {

    const theme = useTheme()
    const [individualUsers, setIndividualUsers] = useState(false)

    const menuProps = selectMenuProps;

    const allDeviceOwnershipSelected = allowedDeviceCategories.length === deviceOwnership.length

    const filter = createFilterOptions();

    const handleUploadedDeviceOwnership = (event, selectedOptions, reason) => {
        if (reason === "select-option" || reason === "remove-option") {
            if (selectedOptions.find((option) => option === "Select All")) {

                if (!allDeviceOwnershipSelected) {
                    handleUserDeviceOwnership([...allowedDeviceCategories]);
                } else {
                    handleUserDeviceOwnership([]);
                }
            } else {
                handleUserDeviceOwnership(selectedOptions)
            }
        } else if (reason === "clear") {
            handleUserDeviceOwnership([]);
        }
    };

    const handleUserDeviceOwnershipRenderer = (props, option, state) => {
        const selected = state?.selected ?? false;
        const selectAllProps =
            option === "Select All"
                ? { checked: allDeviceOwnershipSelected }
                : {};
        return (
            <li {...props} key={props.key}>
                <Checkbox
                    color="primary"
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    {...selectAllProps}
                />
                {option != null ? option.toString() : "Select All"}
            </li>
        );
    };


    return (
        <Fragment>
            <label className="title" style={{ fontSize: "14px", fontWeight: "bold" }}>Users</label>
            <div className="content-block position-relative send-notification-users" style={{ marginTop: "10px", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                <Box className="py-15 send-notification-users-block" sx={userSelectionBlockSx}>
                    {!broadcastNotification && (
                            <Box className="send-notification-users-row" sx={userSelectionFieldRowSx}>
                                <label className="title" style={{ color: 'black', fontSize: '14px' }}>Upload User Ids CSV File</label>
                                <Box sx={formControlSx(theme)} style={{ width: '100%', maxWidth: 280 }}>
                                    <input
                                        className="md border-1"
                                        placeholder="Upload User Ids List"
                                        accept=".csv"
                                        type="file"
                                        {...(() => {
                                            if (uploadedUserIdFileInput === "") {
                                                return { value: "" }
                                            }
                                            else {
                                                return {}
                                            }
                                        })()}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                        name={uploadedUserIdFileInput?.name ?? uploadedUserIdFileInput}
                                        onChange={(e) => {
                                            handleUserIdFileInput(e.target.files[0])
                                            setIndividualUsers(!individualUsers)
                                        }}
                                        ref={userIdCSVFileInputRef}
                                    />
                                </Box>
                            </Box>
                    )}
                    {!individualUsers && getNotificationPermission([], "userCountrySelection", 'level', userLevel) && (
                        <Box className="send-notification-users-row" sx={userSelectionFieldRowSx}>
                            <label className="title" style={{ color: 'black', fontSize: '14px' }}>Broadcast Notification</label>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked = {broadcastNotification}
                                            onChange={(e) => {
                                                handleBroadcastNotification(e.target.checked)
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={"Broadcast Notification"}
                                />
                            </div>
                        </Box>
                    )}
                    {broadcastNotification && getNotificationPermission([], "userCountrySelection", 'level', userLevel) && (
                        <Box className="send-notification-users-row" sx={userSelectionFieldRowSx}>
                            <label className="title" style={{ color: 'black', fontSize: '14px' }}>Country</label>
                            <Box sx={formControlSx(theme)} style={{ width: "100%" }}>
                                <FormControl variant="outlined" sx={selectValuesSx(theme)} style={{ width: "100%" }}>
                                    <InputLabel id="select-outlined-label-country-name" className="title">Select Country</InputLabel>
                                    <Select
                                        labelId="select-outlined-label-country-name"
                                        id="select-outlined-country-name-id"
                                        value={country}
                                        onChange={(e) => {
                                            handleUserCountries(e.target.value)
                                        }}
                                        label="Select Country"
                                        sx={selectInputSx}
                                        MenuProps={menuProps}
                                    >
                                        <MenuItem key={"None"} value={"None"}>{"None"}</MenuItem>
                                        {allowedCountries
                                            ?.filter((country) => getCountryCodeISO(country.toUpperCase()))
                                            .map((country) => (
                                                <MenuItem key={country} value={getCountryCodeISO(country.toUpperCase())}>
                                                    {getCountryCodeISO(country.toUpperCase())}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                    )}

                    {!broadcastNotification && getNotificationPermission([], "userCategorySelection", 'level', userLevel) && (
                            <Box className="send-notification-users-row" sx={userSelectionFieldRowSx}>
                                <label className="title" style={{ color: 'black', fontSize: '14px' }}>Device Ownership:</label>
                                <Box sx={formControlSx(theme)} style={{ width: '100%' }}>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        limitTags={10}
                                        options={allowedDeviceCategories}
                                        value={deviceOwnership}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option != null ? String(option) : ''}
                                        renderOption={handleUserDeviceOwnershipRenderer}
                                        onChange={handleUploadedDeviceOwnership}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Select Device Ownerships" placeholder="Search" fullWidth />
                                        )}
                                        filterOptions={(options, params) => {
                                            const filtered = filter(options, params);
                                            return ["Select All", ...filtered];
                                        }}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        ListboxProps={{ style: { maxHeight: 250 } }}
                                        style={{ width: "100%", minWidth: 0 }}
                                    />
                                </Box>
                            </Box>
                    )}
                    {/* will Implement last login feature for notification later on */}
                    {/* {getNotificationPermission([], "userLoginSelection", 'level', userLevel) && <Grid container style={{ marginBottom: "20px" }}>
                        <Grid item xs={2} style={{ marginLeft: "10px" }}>
                            <label className="title" style={{ color: 'black', fontSize: '14px' }}>Last Login: </label>
                        </Grid>
                        <Grid item xs={3} >
                            <DatePicker
                                selected={userStartLastLogin}
                                maxDate={new Date()}
                                onChange={(date) => {
                                    if (date) {
                                        handleUserStartLastLogin(date.getTime())
                                    }
                                    else {
                                        handleUserStartLastLogin(date)
                                    }
                                }}
                                placeholderText="Start Login Date"
                                dateFormat='MM/dd/yyyy'
                                className="add-input calendar input_phone"
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <DatePicker
                                selected={userEndLastLogin}
                                maxDate={new Date()}
                                onChange={(date) => {
                                    if (date) {
                                        handleUserEndLastLogin(date.getTime())
                                    }
                                    else {
                                        handleUserEndLastLogin(date)
                                    }
                                }}
                                placeholderText="End Login Date"
                                dateFormat='MM/dd/yyyy'
                                className="add-input calendar input_phone"
                            />
                        </Grid>
                    </Grid>} */}
                </Box>
            </div>
        </Fragment>
    );
}


export default UserSelection